import { render } from "./EditorMarkdownNoticias.vue?vue&type=template&id=1a903ba1&scoped=true"
import script from "./EditorMarkdownNoticias.vue?vue&type=script&lang=js"
export * from "./EditorMarkdownNoticias.vue?vue&type=script&lang=js"

import "./EditorMarkdownNoticias.vue?vue&type=style&index=0&id=1a903ba1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a903ba1"]])

export default __exports__